/* eslint-disable */
import utils from 'utils/utils';

import audio from 'icons/audio.svg';
import audioMuted from 'icons/audio-muted.svg';
import audioHalf from 'icons/audio-half.svg';
import captions from 'icons/captions.svg';
import chevronRight from 'icons/chevron-right.svg';
import fullscreenOff from 'icons/fullscreen-off.svg';
import fullscreenOn from 'icons/fullscreen-on.svg';
import pause from 'icons/pause.svg';
import play from 'icons/play.svg';
import playlist from 'icons/playlist.svg';
import settings from 'icons/settings.svg';
import share from 'icons/share.svg';
import info from 'icons/info.svg';

import avButton from 'icons/av-button.svg';
import defs from 'icons/defs.svg';

const iconsMap = {
    '.jw-svg-icon-play': play,
    '.jw-svg-icon-pause': pause,
    '.jw-skip-icon .jw-svg-icon-next': chevronRight,
    '.jw-svg-icon-settings': settings,
    '.jw-svg-icon-sharing': share,

    '.jw-svg-icon-cc-on': captions,
    '.jw-svg-icon-cc-off': captions,

    '.jw-svg-icon-volume-0': audioMuted,
    '.jw-svg-icon-volume-50': audioHalf,
    '.jw-svg-icon-volume-100': audio,

    '.jw-svg-icon-fullscreen-on': fullscreenOn,
    '.jw-svg-icon-fullscreen-off': fullscreenOff,

    'info': info,
    'avButton': avButton
};

let defsLoaded = false;

const loadIcons = function(container) {
    utils.each(iconsMap, (customIcon, selector) => {
        const icons = Array.prototype.slice.call(container.querySelectorAll(selector));

        if (icons.length > 0) {
            utils.each(icons, icon => {
                if (icon) {
                    const svpIcon = utils.createNode(customIcon);
                    svpIcon.setAttribute('class', icon.getAttribute('class'));
                    icon.parentNode.replaceChild(svpIcon, icon);
                }
            });
        }
    });
};

const loadDefs = function (svpPlayer) {
    if(defsLoaded === false) {
        defsLoaded = true;

        svpPlayer.once('ready', () => {
            const container = svpPlayer.getContainer();

            if(container) {
                container.appendChild(utils.createNode(defs));
            }
        });
    }
};

const getIcon = function (name) {
    return iconsMap[name];
};

export { getIcon, loadDefs }

export default (svpPlayer) => {
    const jwPlayer = svpPlayer.player;

    jwPlayer.once('playlist', () => loadIcons(svpPlayer.getContainer()));
}
